import firebase from '../../firebase';

const exportData = (data) => firebase.functions().httpsCallable('requestExport')(data);

export default exportData;
